(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["leaf-newsletter-horizon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__leafHorizonLoaded) return;
    window.__leafHorizonLoaded = true;

    // ===================================================
    // EINSTELLUNGEN
    // ===================================================

    // Desktop-Formation (ausgelegt auf 180px Blätter)
    // fx = Anteil der Breite ab Mitte, y = px bei 180px Blattgröße
    // u = Position im freien Bereich neben dem Text: 0 = am Section-Rand, 1 = am Text.
    //     Abgeleitet aus Julians Koordinaten (fx = Anteil der Breite) bei 1440 px Breite.
    //     So schrumpft die ganze Formation mit dem freien Platz, statt dass die Blätter
    //     bei schmaleren Fenstern aufeinanderrutschen.
    // y = Versatz in px bei 180 px Blattgröße (skaliert mit der Blattgröße)
    var SIDE_LAYOUT = [
      { side: -1, u: 0.34, y: -76,  rot: -9,  scale: 0.80, speed: 1.2, startX: -100 }, // Blatt 1 (fx -0.40)
      { side: -1, u: 0.61, y: -28,  rot: 47,  scale: 0.85, speed: 0.9, startX: -60 },  // Blatt 2 (fx -0.32)
      { side: -1, u: 0.20, y: 9,    rot: -53, scale: 1.00, speed: 1.4, startX: -80 },  // Blatt 3 (fx -0.44)
      { side: 1,  u: 0.58, y: -150, rot: 65,  scale: 1.00, speed: 1.1, startX: 80 },   // Blatt 4 (fx 0.33)
      { side: 1,  u: 0.00, y: -20,  rot: -12, scale: 1.10, speed: 1.5, startX: 120 },  // Blatt 5 (fx 0.50)
      { side: 1,  u: 0.24, y: 60,   rot: -43, scale: 1.00, speed: 0.8, startX: 60 }    // Blatt 6 (fx 0.43)
    ];

    // Freier Bereich je Seite im Entwurf: 2,36 × 180 px = 424 px (bei 1440 px Breite).
    // Ist weniger frei, schrumpft die Formation proportional.
    var ZONE_PER_LEAF = 2.36;

    // Mobil-Formation (Handy, Tablet hochkant, schmale Fenster) – Entwurf 01.10.2026.
    // Gemessen an einem Handy mit 379 px Breite. Abstände in px:
    // left/right = Blattmitte vom linken/rechten Section-Rand, top = vom oberen Section-Rand,
    // size = Blattgröße. Alles skaliert mit der Breite (MOBILE_REF_W), siehe MOBILE_SCALE_MIN/MAX.
    // Die Blätter sind bewusst am Rand angeschnitten.
    var MOBILE_LAYOUT = [
      { left: 6.5,  top: 33,   rot: -150, size: 49.5, speed: 1.2, startX: -40 }, // links außen (angeschnitten)
      { left: 45,   top: 47.5, rot: 86,   size: 63.5, speed: 0.9, startX: -30 }, // links daneben
      { right: 13.5, top: 73,  rot: -101, size: 56.5, speed: 1.1, startX: 40 }   // rechts (angeschnitten)
    ];
    var MOBILE_REF_W = 379;      // Breite des Entwurfs
    var MOBILE_BASE = 60;        // Referenz-Blattgröße für --leaf-size im Mobil-Layout
    var MOBILE_SCALE_MIN = 0.85; // kleinste Skalierung (sehr schmale Handys)
    var MOBILE_SCALE_MAX = 1.3;  // größte Skalierung (Tablets / schmale Fenster)
    var MOBILE_TEXT_GAP = 8;     // Mindestabstand Blatt ↔ Text/Formular im Mobil-Layout (px)

    // Umriss des Blatts (aus dem SVG-Pfad), Koordinaten relativ zur Blatt-Mitte bei Blattgröße 1
    var LEAF_OUTLINE = [0.143,0.500,0.151,0.489,0.174,0.457,0.203,0.407,0.233,0.340,0.257,0.258,0.269,0.164,0.263,0.060,0.231,-0.053,0.178,-0.162,0.115,-0.254,0.048,-0.331,-0.020,-0.393,-0.081,-0.441,-0.131,-0.474,-0.166,-0.494,-0.178,-0.500,-0.184,-0.487,-0.200,-0.450,-0.221,-0.394,-0.242,-0.322,-0.260,-0.238,-0.269,-0.147,-0.266,-0.052,-0.246,0.042,-0.207,0.132,-0.152,0.217,-0.088,0.295,-0.022,0.363,0.041,0.420,0.093,0.463,0.129,0.490];

    // Ausweich-Varianten, wenn ein Blatt Text berühren würde (in dieser Reihenfolge probiert):
    // push = nach außen/oben schieben (Anteil der Blattgröße), shrink = verkleinern
    var MOBILE_TRIES = [];
    [1, 0.9, 0.8, 0.7, 0.6].forEach(function (shrink) {
      [0, 0.15, 0.3, 0.45].forEach(function (push) { MOBILE_TRIES.push({ push: push, shrink: shrink }); });
    });

    // Umriss eines Blatts an Position x/y (Mitte), Drehung rot (Grad), Größe size (px)
    function leafPolygon(x, y, rot, size) {
      var r = rot * Math.PI / 180, c = Math.cos(r), sn = Math.sin(r), pts = [];
      for (var i = 0; i < LEAF_OUTLINE.length; i += 2) {
        var px = LEAF_OUTLINE[i] * size, py = LEAF_OUTLINE[i + 1] * size;
        pts.push([x + px * c - py * sn, y + px * sn + py * c]);
      }
      return pts;
    }

    function pointInPolygon(x, y, pts) {
      var inside = false;
      for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) {
        var xi = pts[i][0], yi = pts[i][1], xj = pts[j][0], yj = pts[j][1];
        if ((yi > y) !== (yj > y) && x < (xj - xi) * (y - yi) / (yj - yi) + xi) inside = !inside;
      }
      return inside;
    }

    // Berührt das Blatt (Polygon) eines der Rechtecke (Text-Zeilen, Formular)?
    function polygonHitsRects(pts, rects, gap) {
      for (var k = 0; k < rects.length; k++) {
        var R = rects[k], l = R.left - gap, rr = R.right + gap, t = R.top - gap, b = R.bottom + gap;
        for (var i = 0; i < pts.length; i++) {
          if (pts[i][0] >= l && pts[i][0] <= rr && pts[i][1] >= t && pts[i][1] <= b) return true;
        }
        var corners = [[l, t], [rr, t], [l, b], [rr, b], [(l + rr) / 2, t], [(l + rr) / 2, b]];
        for (var m = 0; m < corners.length; m++) {
          if (pointInPolygon(corners[m][0], corners[m][1], pts)) return true;
        }
      }
      return false;
    }

    var LEAF_MAX = 180;      // Desktop-Größe (darauf beziehen sich die Koordinaten)
    var LEAF_MIN_SIDE = 95;  // kleiner → Kompakt-Modus
    var LEAF_HEIGHT_RATIO = 2.0; // Blattgröße höchstens Section-Höhe / 2 (größer = kleinere Blätter, weniger angeschnitten)
    var LEAF_ASPECT = 0.54;      // sichtbare Blattbreite / Blatthöhe (für „komplett im Bild“)
    var FIT_MARGIN = 6;          // Abstand zum Section-Rand in px, wenn Blätter komplett im Bild sein sollen
    var LEAF_MIN_HEIGHT = 60;    // so klein werden Blätter durch eine flache Section höchstens
    var TEXT_GAP = 16;       // Mindestabstand Blatt ↔ Text
    var LEAF_HALF = 0.4;     // halbe sichtbare Blattbreite (Anteil der Blattgröße)

    // Scroll-Verhalten: Standardwerte – werden von den Reglern im Theme-Editor überschrieben
    // Müssen mit den "default"-Werten im Schema übereinstimmen – sie greifen,
    // solange eine bestehende Section noch nicht neu gespeichert wurde.
    var DEFAULTS = {
      smoothing: 1,      // Reaktion (1 = sehr träge, 30 = direkt)       → /1000
      holdStart: 70,     // Blätter kommen an bei x % des Scrollwegs
      holdLength: 20,    // Haltedauer in % des Scrollwegs
      flyDistance: 70,   // Flugweite in % der Bildschirmhöhe
      overshoot: 5,      // Nachfedern (0 = keins, 30 = stark)            → /10
      spin: 180,         // Drehung beim Ein-/Abflug in Grad
      scrollOffset: 50,  // Startpunkt verschieben (−50 später … +50 früher) in % der Bildschirmhöhe
      maxSpeed: 10,       // Maximale Geschwindigkeit in % (100 = ungebremst)
      leafScale: 100,    // Blattgröße in % (Schema-Default leaf_scale)
      offsetLeft: 0,     // Endposition linke Blätter: + = tiefer, in px (Schema-Default leaf_offset_left)
      offsetRight: 0     // Endposition rechte Blätter: + = tiefer, in px (Schema-Default leaf_offset_right)
    };

    // Höchsttempo bei 100 % (Animationsfortschritt pro Sekunde)
    var MAX_SPEED = 0.6;

    function readNumber(el, attr, fallback) {
      var v = parseFloat(el.getAttribute(attr));
      return isNaN(v) ? fallback : v;
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    // Ease Out Back: leichtes Überschwingen am Ziel (c1 = Stärke)
    function easeOutBack(x, c1) {
      var c3 = c1 + 1;
      return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }

    // Ease In Quad: sanfter Abflug
    function easeInQuad(x) {
      return x * x;
    }

    function clamp01(v) {
      return Math.max(0, Math.min(1, v));
    }

    // ===================================================
    // EINE INSTANZ PRO SECTION
    // ===================================================
    function LeafNewsletter(root) {
      this.root = root;
      this.layer = root.querySelector('[data-leaf-hz-layer]');
      this.content = root.querySelector('[data-leaf-hz-content]');
      this.template = root.querySelector('[data-leaf-hz-template]');
      this.animate = root.getAttribute('data-animate') !== 'false' && !reduceMotion.matches;

      // Regler-Werte aus dem Theme-Editor
      var holdStart = readNumber(root, 'data-hold-start', DEFAULTS.holdStart) / 100;
      var holdLength = readNumber(root, 'data-hold-length', DEFAULTS.holdLength) / 100;
      this.smoothing = Math.max(0.001, readNumber(root, 'data-smoothing', DEFAULTS.smoothing) / 1000);
      this.holdStart = Math.max(0.01, Math.min(0.95, holdStart));
      this.holdEnd = Math.min(0.99, this.holdStart + holdLength);
      this.flyDistance = readNumber(root, 'data-fly-distance', DEFAULTS.flyDistance) / 100;
      this.overshoot = readNumber(root, 'data-overshoot', DEFAULTS.overshoot) / 10;
      this.spin = readNumber(root, 'data-spin', DEFAULTS.spin);
      this.scrollOffset = readNumber(root, 'data-scroll-offset', DEFAULTS.scrollOffset) / 100;
      this.maxSpeed = MAX_SPEED * Math.max(5, readNumber(root, 'data-max-speed', DEFAULTS.maxSpeed)) / 100;
      // Blattgröße in % (über 100 = größer und am Rand angeschnitten). Ersatzwert = Schema-Default.
      this.leafScale = Math.max(0.3, readNumber(root, 'data-leaf-scale', DEFAULTS.leafScale) / 100);
      this.showMobile = root.getAttribute('data-show-mobile') !== 'false'; // leer = Schema-Default true
      this.offsetLeft = readNumber(root, 'data-offset-left', DEFAULTS.offsetLeft);
      this.offsetRight = readNumber(root, 'data-offset-right', DEFAULTS.offsetRight);

      this.leaves = [];
      this.target = 0;
      this.current = 0;
      this.visible = false;
      this.raf = null;
      this.last = 0;
      this.resizeTimer = null;

      this.onScroll = this.updateTarget.bind(this);
      this.onResize = this.handleResize.bind(this);
      this.tick = this.tick.bind(this);

      this.build();
      this.layout();
      this.autoPlay = false;
      this.updateTarget();
      // Bei automatischem Einflug außerhalb des Bildes starten
      this.current = this.animate && this.autoPlay ? 0 : this.target;
      this.render();

      window.addEventListener('resize', this.onResize);

      // Inhalt ändert sich (z. B. Block im Theme-Editor bearbeitet) → neu anordnen
      if (this.content && 'ResizeObserver' in window) {
        this.contentObserver = new ResizeObserver(this.onResize);
        this.contentObserver.observe(this.content);
      }

      if (this.animate) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        var self = this;
        this.observer = new IntersectionObserver(function (entries) {
          self.visible = entries[0].isIntersecting;
          self.updateTarget();
          if (self.visible) self.start();
        }, { rootMargin: '100px 0px' });
        this.observer.observe(root);
      }

      if (document.fonts && document.fonts.ready) {
        var that = this;
        document.fonts.ready.then(function () {
          if (!that.root) return;
          that.layout();
          that.render();
        });
      }
    }

    LeafNewsletter.prototype.build = function () {
      if (!this.layer || !this.template) return;
      var html = this.template.innerHTML;
      var count = Math.max(SIDE_LAYOUT.length, MOBILE_LAYOUT.length);

      this.layer.querySelectorAll('.leaf-hz__leaf').forEach(function (el) { el.remove(); });
      this.leaves = [];

      for (var i = 0; i < count; i++) {
        var el = document.createElement('div');
        el.className = 'leaf-hz__leaf';
        el.innerHTML = html;
        this.layer.appendChild(el);
        this.leaves.push({ el: el, cfg: null });
      }
    };

    // Sichtbarer Inhalt (Text, Eingabefeld, Button …) relativ zur Section.
    // Theme-Blöcke wie "Gruppe" sind oft 100 % breit, obwohl der Text schmal
    // ist – deshalb werden die einzelnen sichtbaren Elemente gemessen.
    // HORIZON-CHECK [HC-05] Klassenname aus blocks/email-signup.liquid
    var CONTENT_SELECTOR = 'h1,h2,h3,h4,h5,h6,p,li,input,button,select,textarea,img,svg,video,.email-signup__input-group';

    LeafNewsletter.prototype.contentBox = function () {
      var rootRect = this.root.getBoundingClientRect();
      var box = null;
      if (this.content) {
        this.content.querySelectorAll(CONTENT_SELECTOR).forEach(function (el) {
          if (el.closest('[data-leaf-hz-layer]')) return;
          var r = el.getBoundingClientRect();
          if (r.width < 2 || r.height < 2) return;
          if (!box) box = { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
          else {
            box.left = Math.min(box.left, r.left);
            box.right = Math.max(box.right, r.right);
            box.top = Math.min(box.top, r.top);
            box.bottom = Math.max(box.bottom, r.bottom);
          }
        });
      }
      var cx = rootRect.left + rootRect.width / 2;
      var cy = rootRect.top + rootRect.height / 2;
      if (!box) box = { left: cx, right: cx, top: cy, bottom: cy };
      // Koordinaten relativ zur Mitte der Section
      return { left: box.left - cx, right: box.right - cx, top: box.top - cy, bottom: box.bottom - cy };
    };

    var MOBILE_QUERY = window.matchMedia('(max-width: 749px)'); // Horizon-Breakpoint Handy

    // Rechtecke aller sichtbaren Text-ZEILEN (nicht der ganzen Blöcke – die sind auf dem Handy
    // oft volle Breite) plus Formularfelder, relativ zur Section-Mitte.
    LeafNewsletter.prototype.textRects = function () {
      var rootRect = this.root.getBoundingClientRect();
      var cx = rootRect.left + rootRect.width / 2, cy = rootRect.top + rootRect.height / 2;
      var out = [];
      function add(r) {
        if (r.width < 1 || r.height < 1) return;
        out.push({ left: r.left - cx, right: r.right - cx, top: r.top - cy, bottom: r.bottom - cy });
      }
      if (!this.content) return out;
      var walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
      });
      var range = document.createRange(), node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && node.parentElement.closest('[data-leaf-hz-layer], .visually-hidden, script, style, template')) continue;
        range.selectNodeContents(node);
        Array.prototype.forEach.call(range.getClientRects(), add);
      }
      this.content.querySelectorAll('input, button, select, textarea, .email-signup__input-group').forEach(function (el) {
        add(el.getBoundingClientRect());
      });
      return out;
    };

    LeafNewsletter.prototype.getConfigs = function () {
      var root = this.root;

      root.classList.remove('leaf-hz--no-leaves');
      var offLm = 0, offRm = 0; // Höhen-Regler gelten nur für das Desktop-Layout

      var leafMax = LEAF_MAX * this.leafScale;
      var w = root.clientWidth || window.innerWidth;
      var half = w / 2;
      var box = this.contentBox();

      // Freier Bereich links und rechts vom Inhalt (Section-Rand bis Text minus Abstand)
      var zoneL = Math.max(0, (box.left - TEXT_GAP) + half);
      var zoneR = Math.max(0, half - (box.right + TEXT_GAP));
      // Grundgröße wie bisher: Section-Höhe / LEAF_HEIGHT_RATIO × Blattgröße-Regler (höchstens 180 px × Regler)
      var h = root.clientHeight || 0;
      var heightSize = (h > 0 ? h / LEAF_HEIGHT_RATIO : LEAF_MAX) * this.leafScale;
      var baseSize = Math.min(leafMax, heightSize);

      // Ist neben dem Text weniger Platz als im Entwurf (1440 px), schrumpft die ganze Formation
      // im selben Verhältnis – Abstände bleiben gleich, nichts rutscht aufeinander.
      var zoneFactor = Math.min(1, Math.min(zoneL, zoneR) / (ZONE_PER_LEAF * LEAF_MAX));
      var sideSize = baseSize * zoneFactor;

      // Mobil-Layout: Handy (unter 750 px) oder zu wenig Platz neben dem Text
      var compact = MOBILE_QUERY.matches || sideSize < LEAF_MIN_SIDE;

      // Checkbox „Blätter im Mobil-Layout zeigen“ aus → dort keine Blätter
      if (compact && !this.showMobile) {
        root.classList.add('leaf-hz--no-leaves');
        this.mobile = false;
        return [];
      }

      this.mobile = compact; // Mobil: Blätter fliegen nur einmal ein und bleiben dann stehen
      if (compact) {
        // Mobil-Formation: feste Abstände vom Rand/oben, mit der Breite skaliert
        var f = Math.min(MOBILE_SCALE_MAX, Math.max(MOBILE_SCALE_MIN, w / MOBILE_REF_W));
        root.style.setProperty('--leaf-size', Math.round(MOBILE_BASE * f) + 'px');
        var topEdge = -(root.clientHeight || 0) / 2;
        var rects = this.textRects();
        return MOBILE_LAYOUT.map(function (l) {
          var isLeft = l.left !== undefined;
          var x0 = isLeft ? -half + l.left * f : half - l.right * f;
          var y0 = topEdge + l.top * f + (isLeft ? offLm : offRm);
          var size0 = l.size * f;
          // Text darf nie verdeckt werden: Varianten probieren (nach außen/oben schieben, verkleinern)
          for (var i = 0; i < MOBILE_TRIES.length; i++) {
            var t = MOBILE_TRIES[i];
            var size = size0 * t.shrink;
            var x = x0 + (isLeft ? -1 : 1) * t.push * size0;
            var y = y0 - t.push * size0 * 0.6;
            var pts = leafPolygon(x, y, l.rot, size);
            if (!polygonHitsRects(pts, rects, MOBILE_TEXT_GAP)) {
              return {
                x: x,
                y: y,
                rot: l.rot,
                scale: size / (MOBILE_BASE * f),
                speed: l.speed,
                startX: l.startX * f
              };
            }
          }
          return null; // passt nirgends ohne Text zu verdecken → Blatt weglassen
        });
      }

      var s = Math.round(Math.max(LEAF_MIN_HEIGHT, sideSize));
      var k = s / LEAF_MAX;

      root.style.setProperty('--leaf-size', s + 'px');

      if (!compact) {
        var offL = this.offsetLeft, offR = this.offsetRight;
        var fit = this.leafScale <= 1; // bis 100 %: Endposition komplett im Bild
        var hh = (root.clientHeight || 0) / 2;
        return SIDE_LAYOUT.map(function (l) {
          var off = l.side < 0 ? offL : offR; // Höhe der Endpunkte pro Seite (Regler)
          // vom Section-Rand aus in den freien Bereich hinein
          var x = l.side < 0 ? -half + l.u * zoneL : half - l.u * zoneR;
          var y = l.y * k + off;
          if (fit && hh > 0) {
            // Sichtbare Ausdehnung des gedrehten Blatts (Blatt ist ca. 0.54 so breit wie hoch)
            var r = l.rot * Math.PI / 180;
            var c = Math.abs(Math.cos(r)), si = Math.abs(Math.sin(r));
            var extY = 0.5 * s * l.scale * (c + LEAF_ASPECT * si) + FIT_MARGIN;
            var extX = 0.5 * s * l.scale * (LEAF_ASPECT * c + si) + FIT_MARGIN;
            var maxY = Math.max(0, hh - extY), maxX = Math.max(0, half - extX);
            y = Math.max(-maxY, Math.min(maxY, y));
            x = Math.max(-maxX, Math.min(maxX, x));
          }
          return { x: x, y: y, rot: l.rot, scale: l.scale, speed: l.speed, startX: l.startX * k };
        });
      }

    };

    LeafNewsletter.prototype.layout = function () {
      this.getConfigs();                // 1. Durchlauf setzt Modus/Padding
      var configs = this.getConfigs();  // 2. Durchlauf misst mit finalen Maßen
      this.leaves.forEach(function (leaf, i) { leaf.cfg = configs[i] || null; });
    };

    // Wie weit lässt sich die Seite noch nach unten scrollen?
    // Gibt null zurück, wenn das Theme nicht nativ scrollt (z. B. eigenes
    // Smooth-Scrolling mit transform) – dann wird nicht gestaucht.
    var MIN_SCROLL_RANGE = 0.15; // unter 15 % Bildschirmhöhe Scrollweg → Einflug automatisch
    var AUTOPLAY_SMOOTHING = 0.04; // Tempo des automatischen Einflugs

    function remainingScroll(wh) {
      var doc = document.documentElement;
      var body = document.body;
      var height = Math.max(doc.scrollHeight, body ? body.scrollHeight : 0);
      if (height <= wh + 1) return null;
      var scrollY = window.pageYOffset || doc.scrollTop || (body ? body.scrollTop : 0) || 0;
      return Math.max(0, height - wh - scrollY);
    }

    // Fortschritt nur aus der sichtbaren Position der Section berechnen –
    // funktioniert unabhängig davon, wie das Theme scrollt.
    LeafNewsletter.prototype.updateTarget = function () {
      if (!this.root) return;
      var rect = this.root.getBoundingClientRect();
      var wh = window.innerHeight;
      var center = rect.top + rect.height / 2;
      var p = (wh - center) / wh + this.scrollOffset;

      // Liegt die Section nah am Seitenende, reicht der Scrollweg evtl. nicht,
      // um die Halteposition zu erreichen. Dann wird der verfügbare Weg so
      // gestaucht, dass die Blätter am Seitenende mitten in der Haltephase stehen.
      var remaining = remainingScroll(wh);
      if (remaining === null) {
        // Seite scrollt nicht (oder das Theme scrollt auf eigene Art):
        // Einflug automatisch, sobald die Section sichtbar ist.
        this.autoPlay = true;
        p = this.visible ? (this.holdStart + this.holdEnd) / 2 : 0;
      } else {
        var holdMid = (this.holdStart + this.holdEnd) / 2;
        var pMax = p + remaining / wh;                           // Fortschritt ganz unten
        var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
        var pEnter = -rect.height / (2 * wh) + this.scrollOffset; // Section taucht unten auf
        var pLow = Math.max(pEnter, p - scrolled / wh);          // früher geht nicht (Seitenanfang)

        this.autoPlay = false;
        if (pMax < holdMid) {
          if (pMax - pLow < MIN_SCROLL_RANGE) {
            // Kaum Scrollweg: Blätter fliegen von selbst ein, sobald die
            // Section sichtbar ist (und wieder raus, wenn sie verschwindet).
            this.autoPlay = true;
            p = this.visible ? holdMid : 0;
          } else {
            p = holdMid * (p - pLow) / (pMax - pLow);
          }
        }
      }

      p = clamp01(p);

      // Mobil-Layout: nur Einflug, kein Abflug und kein Zurückfliegen.
      // Der Fortschritt geht nie über die Ankunft (holdStart) hinaus und nie zurück.
      if (this.mobile) {
        p = Math.max(Math.min(p, this.holdStart), this.mobileReached || 0);
        this.mobileReached = p;
      }

      this.target = p;
    };

    LeafNewsletter.prototype.handleResize = function () {
      var self = this;
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(function () {
        self.layout();
        self.updateTarget();
        self.render();
      }, 100);
    };

    LeafNewsletter.prototype.start = function () {
      if (this.raf) return;
      this.last = performance.now();
      this.raf = requestAnimationFrame(this.tick);
    };

    LeafNewsletter.prototype.tick = function (now) {
      var dt = Math.min(64, now - this.last);
      this.last = now;

      // Bildraten-unabhängige Trägheit (60 Hz und 120 Hz fühlen sich gleich an)
      // Position jedes Frame neu messen (unabhängig von Scroll-Events)
      if (this.visible) this.updateTarget();

      var k = this.autoPlay ? Math.max(this.smoothing, AUTOPLAY_SMOOTHING) : this.smoothing;
      var f = 1 - Math.pow(1 - k, dt / 16.667);
      var step = (this.target - this.current) * f;
      // Geschwindigkeitsbegrenzung: nie schneller als maxSpeed
      var maxStep = this.maxSpeed * dt / 1000;
      if (step > maxStep) step = maxStep;
      if (step < -maxStep) step = -maxStep;
      this.current += step;
      this.render();

      if (this.visible || Math.abs(this.target - this.current) > 0.001) {
        this.raf = requestAnimationFrame(this.tick);
      } else {
        this.raf = null;
      }
    };

    LeafNewsletter.prototype.render = function () {
      var p = this.current;
      var wh = window.innerHeight;
      var animate = this.animate;
      var holdStart = this.holdStart;
      var holdEnd = this.holdEnd;
      var fly = this.flyDistance;
      var overshoot = this.overshoot;
      var spin = this.spin;

      this.leaves.forEach(function (leaf) {
        var c = leaf.cfg;
        if (!c) {
          leaf.el.style.display = 'none';
          return;
        }
        leaf.el.style.display = '';

        var x = c.x, y = c.y, rot = c.rot;

        if (animate) {
          var startY = -wh * fly * c.speed;
          var endY = wh * fly * c.speed;
          var startX = c.x + c.startX;
          var endX = c.x - c.startX;
          var t;

          if (p < holdStart) {
            // Phase 1: Einflug mit Federn
            t = easeOutBack(clamp01(p / holdStart), overshoot);
            x = startX + (c.x - startX) * t;
            y = startY + (c.y - startY) * t;
            rot = (c.rot - spin) + spin * t;
          } else if (p > holdEnd) {
            // Phase 3: Abflug
            t = easeInQuad(clamp01((p - holdEnd) / (1 - holdEnd)));
            x = c.x + (endX - c.x) * t;
            y = c.y + (endY - c.y) * t;
            rot = c.rot + spin * t;
          }
          // Phase 2 (Halten): Zielposition
        }

        leaf.el.style.transform =
          'translate3d(' + x + 'px,' + y + 'px,0) rotate(' + rot + 'deg) scale(' + c.scale + ')';
      });
    };

    LeafNewsletter.prototype.destroy = function () {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.observer) this.observer.disconnect();
      if (this.contentObserver) this.contentObserver.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
      clearTimeout(this.resizeTimer);
      this.root = null;
    };

    // ===================================================
    // INITIALISIERUNG + THEME-EDITOR
    // ===================================================
    var instances = [];

    function init(scope) {
      (scope || document).querySelectorAll('[data-leaf-hz]').forEach(function (el) {
        var exists = instances.some(function (i) { return i.el === el; });
        if (!exists) instances.push({ el: el, inst: new LeafNewsletter(el) });
      });
    }

    function destroyIn(scope) {
      instances = instances.filter(function (i) {
        if (scope.contains(i.el)) {
          i.inst.destroy();
          return false;
        }
        return true;
      });
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { destroyIn(e.target); });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
